module.exports = __webpack_public_path__ + "img/barryCourseLogo.29c70208.svg";